import React from "react";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative px-6 md:px-10 py-16 border-t border-white/5">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 mb-16">
          <div className="col-span-2">
            <div className="font-display text-3xl font-bold tracking-tighter mb-3">
              Full<span className="holo-text">Stop</span>
            </div>
            <p className="font-serif-accent text-white/60 text-lg max-w-sm">
              El cargador inteligente que se apaga solo al llegar al 100%.
            </p>
          </div>

          <div>
            <h4 className="font-body text-xs text-white/40 uppercase tracking-[0.25em] mb-4">Producto</h4>
            <ul className="space-y-2 font-body text-sm text-white/70">
              <li className="hover:text-white cursor-pointer" onClick={() => document.getElementById("features")?.scrollIntoView({ behavior: "smooth" })}>Ventajas</li>
              <li className="hover:text-white cursor-pointer" onClick={() => document.getElementById("como-funciona")?.scrollIntoView({ behavior: "smooth" })}>Cómo funciona</li>
              <li className="hover:text-white cursor-pointer" onClick={() => document.getElementById("specs")?.scrollIntoView({ behavior: "smooth" })}>Ficha técnica</li>
              <li className="hover:text-white cursor-pointer" onClick={() => document.getElementById("comprar")?.scrollIntoView({ behavior: "smooth" })}>Comprar</li>
            </ul>
          </div>
          <div>
            <h4 className="font-body text-xs text-white/40 uppercase tracking-[0.25em] mb-4">Ayuda</h4>
            <ul className="space-y-2 font-body text-sm text-white/70">
              <li><a className="hover:text-white" href="/legal#aviso">Aviso legal</a></li>
              <li><a className="hover:text-white" href="/legal#privacidad">Privacidad</a></li>
              <li><a className="hover:text-white" href="/legal#terminos">Términos</a></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8 border-t border-white/5">
          <p className="font-body text-xs text-white/40">
            © 2026 FullStop · Todos los derechos reservados
          </p>
          <p className="font-body text-xs text-white/40 flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-[#ff9eeb] animate-pulse" />
            Carga y olvídate
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
